import { gql } from '@apollo/client';

// Query to search for users with privacy filters and access information
export const SEARCH_USERS_GQL = gql`
  query InviteModal_SearchUsers($searchTerm: String!, $currentOrgId: uuid!) {
    user(
      where: {
        _and: [
          { deleted_at: { _is_null: true } }
          { _or: [{ name: { _ilike: $searchTerm } }, { email: { _ilike: $searchTerm } }] }
        ]
      }
      limit: 20
      order_by: { name: asc }
    ) {
      id
      name
      email
      phone_number
      avatar
      user_organizations(where: { organization_id: { _eq: $currentOrgId }, deleted_at: { _is_null: true } }) {
        organization_id
        role_id
        organization {
          id
          name
        }
        role {
          id
          name
        }
        user_organization_notification_tier_assignment {
          tier_id
        }
      }
      user_barns(where: { barn: { organization_id: { _eq: $currentOrgId } }, deleted_at: { _is_null: true } }) {
        barn_id
        role_id
        barn {
          id
          name
          organization_id
          organization {
            id
            name
          }
        }
        role {
          id
          name
        }
      }
    }
  }
`;

// Query to search for exact email match
export const SEARCH_EXACT_EMAIL_GQL = gql`
  query InviteModal_SearchExactEmail($email: String!) {
    user(where: { _and: [{ deleted_at: { _is_null: true } }, { email: { _eq: $email } }] }, limit: 1) {
      id
      name
      email
      phone_number
      avatar
      timezone
      # user_organizations(where: { organization_id: { _eq: $currentOrgId } }) {
      user_organizations {
        organization_id
        role_id
        organization {
          id
          name
        }
        role {
          id
          name
        }
      }
      user_barns {
        barn_id
        role_id
        barn {
          id
          name
          organization_id
          organization {
            id
            name
          }
        }
        role {
          id
          name
        }
      }
    }
  }
`;

// Query to get roles for organization
export const GET_ROLES_QUERY = gql`
  query InviteModal_GetRoles($orgId: uuid!) {
    roles(where: { _or: [{ organization_id: { _eq: $orgId } }, { organization_id: { _is_null: true } }] }) {
      id
      name
      privileges
    }
  }
`;

// Query to get barns for organization
export const GET_BARNS_QUERY = gql`
  query InviteModal_GetBarns($orgId: uuid!) {
    farm(
      where: { _and: [{ deleted_at: { _is_null: true } }, { organization_id: { _eq: $orgId } }] }
      order_by: { name: asc }
    ) {
      id
      name
    }
  }
`;

// plural barns as a reminder it's an array we get back
export const GET_BARNS_BY_PK_QUERY = gql`
  query InviteModal_GetBarnByPK($barnId: uuid!) {
    farm(where: { _and: [{ deleted_at: { _is_null: true } }, { id: { _eq: $barnId } }] }, order_by: { name: asc }) {
      id
      name
    }
  }
`;

// Query to get organization notification plan and tiers
export const GET_ORG_PLAN_AND_TIERS_QUERY = gql`
  query InviteModal_GetOrgPlanAndTiers($orgId: uuid!) {
    organization_notification_plan(where: { organization_id: { _eq: $orgId } }) {
      plan_id
      plan {
        id
        tiers(order_by: { sort_order: desc }) {
          id
          name
          sort_order
          public_description
        }
      }
    }
  }
`;

// Hasura Action mutation for inviting users
export const INVITE_USER_MUTATION = gql`
  mutation InviteModal_InviteUser(
    $userName: String!
    $userEmail: String!
    $userPhoneNumber: String
    $userTimezone: String
    $orgs: [OrgAccess!]
    $barns: [BarnAccess!]
  ) {
    inviteUser(
      userName: $userName
      userEmail: $userEmail
      userPhoneNumber: $userPhoneNumber
      userTimezone: $userTimezone
      orgs: $orgs
      barns: $barns
    ) {
      id
      message
      userId
    }
  }
`;

// Mutation to create user barn notification tier assignment
export const UPSERT_USER_BARN_TIER_ASSIGNMENT_MUTATION = gql`
  mutation InviteModal_UpsertUserBarnTierAssignment($objects: [user_barn_notification_tier_assignment_insert_input!]!) {
    insert_user_barn_notification_tier_assignment(
      objects: $objects
      on_conflict: { constraint: user_barn_notification_tier_assignment_unique, update_columns: [tier_id] }
    ) {
      affected_rows
    }
  }
`;

// Mutation to create user organization notification tier assignment
export const UPSERT_USER_ORG_TIER_ASSIGNMENT_MUTATION = gql`
  mutation InviteModal_UpsertUserOrgTierAssignment(
    $objects: [user_organization_notification_tier_assignment_insert_input!]!
  ) {
    insert_user_organization_notification_tier_assignment(
      objects: $objects
      on_conflict: { constraint: user_organization_notification_tier_assignment_unique, update_columns: [tier_id] }
    ) {
      affected_rows
    }
  }
`;

// Mutation to upsert user notification transport settings
export const UPSERT_USER_NOTIFICATION_TRANSPORT_SETTINGS_MUTATION = gql`
  mutation InviteModal_UpsertUserNotificationTransportSettings(
    $user_id: uuid!
    $sms: Boolean!
    $push: Boolean!
    $email: Boolean!
  ) {
    insert_user_notification_transport_settings(
      objects: { user_id: $user_id, sms: $sms, push: $push, email: $email }
      on_conflict: { constraint: user_notification_transport_settings_pkey, update_columns: [sms, push, email] }
    ) {
      affected_rows
      returning {
        user_id
        sms
        push
        email
      }
    }
  }
`;
